export default __webpack_public_path__ + "pypi/tornado-6.2-py3-none-any.whl";